<div class="console-page">
  <div class="console-content">
    <app-page-header title="Procesador Benefit" description="Integración con procesador Benefit."></app-page-header>
    <form [formGroup]="myForm">
      <app-console-section title="Configuración del procesador">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="pb-token">Token transacción</label>
            <input id="pb-token" class="console-input" formControlName="token" placeholder="Token de la transacción" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-buyOrder">Orden de compra</label>
            <input id="pb-buyOrder" class="console-input" formControlName="buyOrder" placeholder="Número de orden" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-merchantCode">Código comercio (RUC)</label>
            <input id="pb-merchantCode" class="console-input" formControlName="merchantCode" placeholder="RUC del comercio" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-merchantName">Nombre comercio</label>
            <input id="pb-merchantName" class="console-input" formControlName="merchantName" placeholder="Nombre del comercio" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-documentType">Tipo documento</label>
            <select id="pb-documentType" class="console-select" formControlName="documentType" (change)="changeDocumentType($event)">
              <option value="DNI">DNI</option>
            </select>
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-documentNumber">Número documento</label>
            <input id="pb-documentNumber" class="console-input" formControlName="documentNumber" placeholder="Número de documento" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-cardId">Card ID</label>
            <input id="pb-cardId" class="console-input" formControlName="cardId" placeholder="ID de la tarjeta" />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Consultar millas">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="pb-identifier1">Identificador único</label>
            <input id="pb-identifier1" class="console-input" formControlName="identifier1" readonly placeholder="Identificador generado" />
          </div>
        </div>
        <div class="console-actions">
          <button class="console-btn console-btn--primary" type="button" (click)="consultarMillas()">Consultar millas</button>
        </div>
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="pb-result1">Resultado consulta</label>
            <input id="pb-result1" class="console-input" formControlName="result1" readonly placeholder="Resultado de la consulta" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-rewardPoints">Millas disponibles</label>
            <input id="pb-rewardPoints" class="console-input" formControlName="rewardPoints" readonly placeholder="Millas disponibles" />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Pagar (enviar OTP)">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="pb-identifier2">Identificador único</label>
            <input id="pb-identifier2" class="console-input" formControlName="identifier2" readonly placeholder="Identificador generado" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-redeemedRewardPoints">Millas a canjear</label>
            <input id="pb-redeemedRewardPoints" class="console-input" formControlName="redeemedRewardPoints" placeholder="Cantidad de millas" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-exchangeRate">Tasa de cambio soles/millas</label>
            <input id="pb-exchangeRate" class="console-input" formControlName="exchangeRate" placeholder="Tasa de cambio" />
          </div>
        </div>
        <div class="console-actions">
          <button class="console-btn console-btn--primary" type="button" (click)="solicitarEnvioOTP()">Pagar (enviar OTP)</button>
        </div>
        <div class="console-field">
          <label class="console-field__label" for="pb-result2">Resultado enviar OTP</label>
          <input id="pb-result2" class="console-input" formControlName="result2" readonly placeholder="Resultado del envío OTP" />
        </div>
      </app-console-section>

      <app-console-section title="Pagar (autorizar canje)">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="pb-identifier3">Identificador único</label>
            <input id="pb-identifier3" class="console-input" formControlName="identifier3" readonly placeholder="Identificador generado" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-verificationCode">Código de verificación</label>
            <input id="pb-verificationCode" class="console-input" formControlName="verificationCode" placeholder="Código OTP recibido" />
          </div>
        </div>
        <div class="console-actions">
          <button class="console-btn console-btn--primary" type="button" (click)="autorizarCanje()">Pagar (autorizar)</button>
        </div>
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="pb-result3">Resultado canje</label>
            <input id="pb-result3" class="console-input" formControlName="result3" readonly placeholder="Resultado del canje" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-authorizationCode">Código de autorización</label>
            <input id="pb-authorizationCode" class="console-input" formControlName="authorizationCode" placeholder="Código de autorización" />
          </div>
        </div>
      </app-console-section>

      <app-console-section title="Anular">
        <div class="console-field">
          <label class="console-field__label" for="pb-identifier4">Identificador único</label>
          <input id="pb-identifier4" class="console-input" formControlName="identifier4" readonly placeholder="Identificador generado" />
        </div>
        <div class="console-actions">
          <button class="console-btn console-btn--danger" type="button" (click)="anularCanje()">Anular</button>
        </div>
        <div class="console-field">
          <label class="console-field__label" for="pb-result4">Resultado anulación</label>
          <input id="pb-result4" class="console-input" formControlName="result4" readonly placeholder="Resultado de la anulación" />
        </div>
      </app-console-section>

      <app-console-section title="Devolver">
        <div class="console-form-grid">
          <div class="console-field">
            <label class="console-field__label" for="pb-identifier5">Identificador único</label>
            <input id="pb-identifier5" class="console-input" formControlName="identifier5" readonly placeholder="Identificador generado" />
          </div>
          <div class="console-field">
            <label class="console-field__label" for="pb-partialRefundedRewardPoints">Millas a devolver</label>
            <input id="pb-partialRefundedRewardPoints" class="console-input" formControlName="partialRefundedRewardPoints" placeholder="Millas a devolver" />
          </div>
        </div>
        <div class="console-actions">
          <button class="console-btn" type="button" (click)="devolverCanje()">Devolver</button>
        </div>
        <div class="console-field">
          <label class="console-field__label" for="pb-result5">Resultado devolución</label>
          <input id="pb-result5" class="console-input" formControlName="result5" readonly placeholder="Resultado de la devolución" />
        </div>
      </app-console-section>
    </form>
  </div>
</div>
